export default function observeElementMutation(
  cb: (value) => void,
  attributeName: string
): MutationCallback {
  const handleMutation: MutationCallback = (mutationsList) => {
    for (const mutation of mutationsList) {
      if (mutation.type === 'attributes') {
        if (mutation.attributeName === attributeName) {
          const element = mutation.target as HTMLElement;
          cb(element[attributeName]);
        }
      }
    }
  };

  return handleMutation;
}
